import { LitElement, html, css } from 'lit';
import '../common.css';
import logo from '../../images/logo.webp';
import favicon from '../../images/favicon.png';
import footerBg from '../../images/footer-bg-logo.webp';

class Footer extends LitElement {
  static get properties() {
    return {};
  }

  constructor() {
    super();
  }

  static get styles() {
    return css`
      * {
        box-sizing: border-box;
      }
      .container {
        max-width: 1200px;
        padding: 0 15px;
        margin: 0 auto;
        color: #454545;
        font-family: "Outfit", sans-serif;
      }
      h6 {
        font-size: 16px;
        font-family: "Inter", sans-serif;
        font-weight: 600;
        color: #222;
      }
      .footer {
        padding: 100px 0 0 0;
      }
      @media (max-width: 767px) {
        .footer {
          padding: 65px 0 0 0;
        }
      }
      .footer .footer-cols {
        display: flex;
        justify-content: space-between;
        margin: 0 -15px 62px -15px;
      }
      @media (max-width: 767px) {
        .footer .footer-cols {
          flex-wrap: wrap;
        }
      }
      .footer .footer-cols .four-cols {
        display: flex;
        justify-content: space-between;
      }
      @media (max-width: 767px) {
        .footer .footer-cols .four-cols {
          justify-content: space-between;
          display: flex;
          flex-wrap: wrap;
        }
      }
      @media (max-width: 767px) {
        .footer .footer-cols .four-cols .col {
          width: 50%;
        }
      }
      .footer .email-col {
        width: 26%;
      }
      @media (max-width: 767px) {
        .footer .email-col {
          width: 100%;
          margin: 0 auto 20px auto;
          text-align: center;
        }
      }
      .footer .email-col .footer-logo {
        margin: 0 0 20px 0;
        display: flex;
        overflow: hidden;
      }
      .footer .email-col .footer-logo .logo-img {
        width: 194px;
        height: 56px;
        object-fit: cover;
        display: block;
        margin-left: -10px;
      }
      .footer .email-col .footer-logo .favicon-img {
        width: 56px;
        height: 56px;
        object-fit: cover;
        display: block;
      }
      @media (max-width: 1024px) {
        .footer .email-col .footer-logo {
          margin: 0 0 10px 0;
          justify-content: center;
        }
      }
      .footer .email-col p {
        margin: 0 0 25px 0;
        font-size: 18px;
      }
      @media (max-width: 1024px) {
        .footer .email-col p {
          font-size: 14px;
        }
      }
      @media (max-width: 767px) {
        .footer .email-col p {
          font-size: 14px;
        }
      }
      .footer .email-col .email {
        margin: 0 0 10px 0;
        transition: all 0.5s ease;
        font-weight: 500;
        display: block;
      }
      @media (max-width: 1024px) {
        .footer .email-col .email {
          margin: 0 0 10px 0;
        }
      }
      .footer .email-col .email:hover {
        cursor: pointer;
        color: #05B0FB;
      }
      .footer .menu-area {
        display: flex;
        justify-content: space-between;
        width: 74%;
      }
      @media (max-width: 1024px) {
        .footer .menu-area {
          width: 100%;
        }
      }
      @media (max-width: 767px) {
        .footer .menu-area {
          display: block;
        }
      }
      .footer .menu-area .col-wrap {
        display: flex;
      }
      @media (max-width: 767px) {
        .footer .menu-area .col-wrap {
          width: 100%;
        }
      }
      .footer .col {
        padding: 0 15px;
      }
      @media (max-width: 767px) {
        .footer .col {
          padding: 0 10px;
          width: 50%;
        }
      }
      .footer .col {
        p {
          margin: 0 0 27px;
        }

        h6 {
          margin: 0 0 16px 0;
        }

        h5 {
          margin: 0 0 10px 0;
        }

        .footer-links {
          padding: 0;
          margin: 0;
        }

        li {
          list-style: none;
        }

        a, button {
          border: unset;
          background-color: unset;
          margin: 0 0 14px 0;
          cursor: pointer;
          font-size: 16px;
          padding: 0;
          text-decoration: none;
          display: inline-block;
          transition: all 0.5s ease;
          color: #454545;

          &:hover {
            color: #05B0FB;
          }

          @media (max-width: 1199px) {
            font-size: 14px;
          }
        }
      }

      @media (max-width: 767px) {
        .footer .col.email-col {
          width: 100%;
        }
      }
      .footer .social-networks {
        display: flex;
        padding: 0;
        margin: 0 -8px;
      }
      @media (max-width: 1024px) {
        .footer .social-networks {
          display: flex;
          justify-content: center;
        }
      }
      @media (max-width: 767px) {
        .footer .social-networks {
          margin: 0 0 40px 0;
        }
      }
      .footer .social-networks li {
        list-style: none;
        padding: 0 8px;
      }
      .footer .social-networks a {
        display: block;
        font-size: 22px;
        text-decoration: none;
        fill: #454545;
      }
      .footer .social-networks a:hover i::before {
        color: #05B0FB;
      }
      .footer .social-networks a i::before {
        color: #454545;
        transition: all 0.5s ease;
      }
      .footer .copyright .footer-text {
        padding: 17px 0 20px 0;
        margin: 0;
        display: flex;
        justify-content: space-between;
        border-top: 2px solid #BABAC5;
      }
      .copyright {
        position: relative;
      }
      .footer-background-logo img {
        width: 100%;
      }
      .footer-background-logo {
        position: absolute;
        bottom: -15px;
        right: 0;
        z-index: -1;
      }
      @media (max-width: 578px) { 
        .footer-background-logo {
          bottom: -25px;
        }
      }
      @media (max-width: 578px) {
        .footer .copyright .footer-text {
          display: block;
          text-align: center;
        }
      }
      .footer .copyright .footer-text li {
        list-style: none;
        color: #454545;
        font-size: 16px;
      }
    `;
  }


  _openCookieConsent() {
    document.dispatchEvent(new CustomEvent('show-cookie-consent', { bubbles: true, composed: true }));
  }

  render() {
    return html`
      <footer class="footer">
        <div class="container">
          <div class="footer-cols">
            <div class="col email-col">
              <strong class="footer-logo">
                <img class="favicon-img" src="${favicon}" alt="Facicon" />
                <img class="logo-img" src="${logo}" alt="Logo" />
              </strong>
              <p>Streamline your investments with a modern platform simplified</p>
              <span class="email"><a href="#">finovva.finance@gmail.com</a></span>
              <ul class="social-networks">
                <li><a href="https://www.linkedin.com/company/finovva" aria-label="Linkedin Profile"><box-icon type='logo' name='linkedin-square'></box-icon></a></li>
                <li><a href="https://www.facebook.com/profile.php?id=61550595639653" aria-label="Facebook Profile"><box-icon name='facebook-circle' type='logo' ></box-icon></a></li>
                <li><a href="https://www.instagram.com/finovva.finance/" aria-label="Instagram Profile"><box-icon name='instagram-alt' type='logo' ></box-icon></a></li>
              </ul>
            </div>
            <div class="col">
              <h6>PAGES</h6>
              <ul class="footer-links">
                <li><a href="/landing">Home</a></li>
                <li><a href="/feature">Features</a></li>
                <li><a href="/pricing">Pricing</a></li>
                <li><a href="/blog">Blog</a></li>
              </ul>
            </div>
            <div class="col">
              <h6>FEATURES</h6>
              <ul class="footer-links">
                <li><a href="/feature-dashboard">Dashboard</a></li>
                <li><a href="/feature-trades">Effortless Trades</a></li>
                <li><a href="/feature-performance">Performance Analytics</a></li>
                <li><a href="/feature-dividends">Dividend Visualization</a></li>
                <li><a href="/feature-news">Real-time News Updates</a></li>
              </ul>
            </div>
            <div class="col">
              <h6>LEGAL</h6>
              <ul class="footer-links">
                <li><a href="/privacy">Privacy Policy</a></li>
                <li><a href="/terms">Terms of Service</a></li>
                <li><button @click="${this._openCookieConsent}">Cookie Preferences</button></li>
              </ul>
            </div>
          </div>
          <div class="copyright">
            <ul class="footer-text">
              <li>2025 @ Finovva LLC. All Rights Reserved</li>
            </ul>
            <div class="footer-background-logo">
              <img src="${footerBg}" alt="Footerlogo">
            </div>
          </div>
        </div>
      </footer>
    `;
  }
}

customElements.define('component-footer', Footer);
